module.exports = __webpack_public_path__ + "static/projectcard2-b4b433a62448aa4971b3569125d01376.png";